import React, { useEffect, useState } from "react"
import useServerSort from "../../../helpers/useServerSort"
import {
  Button,
  Card,
  Col,
  Form,
  FormFeedback,
  FormGroup,
  Label,
  PopoverBody,
  Row,
  UncontrolledPopover,
} from "reactstrap"
import UpdateTable from "../../../components/Common/UpdatedTable"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import action from "../../../assets/icons/action.svg"
import { toastError, toastSuccess } from "../../../helpers/msg_helper"
import { FormProvider, useForm } from "react-hook-form"
import { UFInput } from "../../../components/Common/Fields/Input"
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"
import LoadingButton from "../../../components/Common/LoadingButton"
import {
  fetchShiftEdit,
  fetchHrmsShift,
  postHrmsShift,
  updateShiftStatus,
} from "../../../services/Hrms/hrms"
import HrmsSearch from "../search"

const schema = yup.object().shape({
  name: yup.string().required("Shift is Required"),
})
const ShiftMaster = () => {
  const companyname = localStorage.getItem('companyname')
  document.title = `Shifts${companyname ? ` | ${companyname}` : ''}`;

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
  } = useForm({
    resolver: yupResolver(schema),
  })
  const methods = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    shouldFocusError: true,
    defaultValues: {
      name: "",
    },
  })
  const [isLoading, setIsLoading] = useState(false)

  const [page, setPage] = useState("")

  const [gradeList, setGrade] = useState()
  const [count, setCount] = useState(0)
  const [search, setSearch] = useState("")
  const [editGrade, setEditGrade] = useState("")

  const { sortParam, handleServerSort } = useServerSort(() => setPage(1))
  useEffect(() => {
    const fetchData = async () => {
      const response = await fetchHrmsShift({
        params: `${search ? `&searchText=${search}` : "&searchText"}${
          page ? `&page=${page}` : ""
        }${sortParam}${`&sizePerPage=16`}`,
      })
      setGrade(response)
    }
    fetchData()
  }, [count, search, page, sortParam])

  useEffect(() => {
    if (editGrade.id) {
      reset({ ...editGrade })
    }
  }, [editGrade.id])

  const handleGrade = async data => {
    try {
      setIsLoading(true)
      const createdSeries = await postHrmsShift(data)
      toastSuccess(createdSeries?.message)
      reset({
        grade: "",
      })
      setCount(count + 1)
    } catch (err) {
      toastError(err?.message)
    } finally {
      setIsLoading(false)
      setEditGrade("")
    }
  }

  const handleEdit = async item => {
    const response = await fetchShiftEdit(item)
    setEditGrade(response?.data)
  }

  const handleStatus = async id => {
    try {
      const response = await updateShiftStatus(id)
      toastSuccess(response?.message)
      setCount(count + 1)
    } catch (err) {
      toastError(err?.message)
    }
  }

  const columns = [
    {
      label: "Code",
      renderCell: item => (
        <div className="capitalize-letter">{item?.code}</div>
      ),
    },
    {
      label: "Shift",
      renderCell: item => (
        <div className="capitalize-letter">{item?.name}</div>
      ),
      sortKey: "name",
    },
    {
      label: "Status",
      renderCell: item => (
        <div>
          <div
            className={`font-13 ${
              item?.status === 1 ? "status-active" : "status-inactive"
            }`}
          >
            {item?.status === 1 ? "Active" : "Inactive"}
          </div>
        </div>
      ),
    },
    {
      label: "Action",
      renderCell: item => (
        <>
          <div>
            <span id={`PopoverLegacy-${item?.id}`}>
              <img src={action} alt="" className="pointer" />
            </span>
          </div>
          <UncontrolledPopover
            placement="bottom"
            target={`PopoverLegacy-${item?.id}`}
            trigger="legacy"
          >
            <PopoverBody>
              {item?.status === 1 && (
                <div
                  className="table-popup-content"
                  onClick={() => handleEdit(item?.id)}
                >
                  Edit
                </div>
              )}
              <div
                className={`${
                  item?.status === 1 ? "popover-border" : ""
                } table-popup-content`}
                onClick={() => handleStatus(item?.id)}
              >
                {item?.status === 1 ? "Deactivate" : "Activate"}
              </div>
            </PopoverBody>
          </UncontrolledPopover>
        </>
      ),
    },
  ]

  const handlePaginate = page => {
    setPage(page)
  }

  const handleSearchChange = data => {
    setSearch(data)
    setPage(1)
  }

  const handleCancel = () => {
    reset({
      name: "",
    })
    setEditGrade("")
  }

  return (
    <React.Fragment>
      <div className="page-content tnt-scope">
        <div className="container-fluid">
          <div className="d-flex justify-content-between">
            <Breadcrumbs
              title="HRMS"
              breadcrumbObject={[
                { title: "HRMS", link: "/hrms" },
                { title: "Shifts", link: "/hrms-shift" },
              ]}
            />
          </div>

          <Row className="mt-2">
            <Col xs={5}>
              <Card className="me-2 px-2 pb-2 input-card">
                <div className="input-card-head">
                  {editGrade?.id ? "Edit" : "Add"}
                </div>
                <hr className="table-divide" />
                <FormProvider {...methods}>
                  <Form id={`ev-form`} onSubmit={handleSubmit(handleGrade)}>
                    <Row className="mt-2">
                      <Col sm={12}>
                        <FormGroup className="mb-4">
                          <Label>
                            Shift<span className="mandatory">*</span>
                          </Label>
                          <UFInput
                            control={control}
                            placeholder="Enter the Shift"
                            name={"name"}
                            invalid={!!errors.name}
                          />
                          <FormFeedback invalid>
                            {errors.name?.message}
                          </FormFeedback>
                        </FormGroup>
                        <div className="float-end">
                          <Button
                            className="btn-secondary me-2"
                            form={`ev-form`}
                            color={"secondary"}
                            onClick={handleCancel}
                          >
                            Cancel
                          </Button>
                          <LoadingButton
                            form={`ev-form`}
                            color={"primary"}
                            loading={isLoading}
                            disabled={isLoading}
                            type="submit"
                          >
                            {editGrade?.id ? "Update" : "Create"}
                          </LoadingButton>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                </FormProvider>
              </Card>
            </Col>
            <Col xs={7}>
              <Card className="me-2 px-2 pb-2 main-dashboard-bg">
                <HrmsSearch
                  handleSearchChange={handleSearchChange}
                  placeholder="search"
                />
                <hr className="table-divide" />
                <Row className="mt-2 ever-rise-table">
                  <Col xs={12}>
                    {gradeList?.data?.data && (
                      <UpdateTable
                        className="mt-5"
                        nodes={gradeList?.data?.data}
                        paginate={gradeList?.data}
                        columns={columns}
                        CurrentPage={page}
                        handlePagination={handlePaginate}
                        handleServerSort={handleServerSort}
                        tableWidth="30% 30% 30% 10%"
                      />
                    )}
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  )
}

export default ShiftMaster
